module.exports = __webpack_public_path__ + "img/jetski_icon.844c9c7e.svg";